import React from "react";

function TextNormalWithHtml(props) {
    var text = props.text;
  return (
    <p className="mb-4" dangerouslySetInnerHTML={{__html: text}}></p>
  );
}

export default TextNormalWithHtml;